import React from "react";
import "./Review.css";
import Slider from "react-slick";
import { FaStarHalf } from "react-icons/fa";
import { LiaStarSolid } from "react-icons/lia";
import { FcGoogle } from "react-icons/fc";
import image2 from "../Images/unnamed (1).png";
import image1 from "../Images/unnamed (5).png";
import image4 from "../Images/unnamed.png";
import image5 from "../Images/unnamed (3).png";
import image6 from "../Images/unnamed (4).png";
import image7 from"../Images/unnamed (7).png"

const reviews = [
  {
    name: "Suraj Mehara",
    feedback:
      "Thank you doc. Experience doctor in surat, with excellent communication skills and patient care, best psychiatrist in surat",

    img: image6,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
    ],
  },
  {
    name: "Janki Bhadaniya",
    feedback:
      "I was feeling depressed after my c section delivery,I contacted Dr.Anant changela his medicine was very helpful for my mental health.i can't thanks enough for the special care and your humble response. I m blessed that you are my doctor.i have great confident in you and your great abilities.Thanks alot Best doctor in surat.",

    img: image5,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
    ],
  },
  {
    name: "Rizawan khan",
    feedback:
      "Dr Anant Changela psychiatric ,I hade very good experience under his treatment Due to I have suffer lots with other . The way he is understand problem of the patient it was commendable .",

    img: image4,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
    ],
  },

  {
    name: "Suman Vala",
    feedback:
      "My father is a case of bipolar mood disorder, with treatment no any complain and symptoms free thank you doctor, best psychiatrist in surat",

    img: image6,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
    ],
  },
  {
    name: "Vinit Sharma",
    feedback:
      "The doctor is really patient and hears every detail to the best . He explains the condition and treatment plan too in good detail and an easy way to comprehend . Overall my experience was really good . And i give high regards to his treatment .",

    img: image1,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <FaStarHalf />,
    ],
  },
  {
    name: "Ketan rathod",
    feedback:
      "Our experience with DrAnant .is very good and treatment is excellent, he is very good at his work and the atmosphere is good for patient-The nature of the doctor is goo-psymexa is Very nice place . Staff is very cooperative. Good experience for mental health Best psychiatrist clinic in Surat .Doctor is also giving positive energy to patient.",

    img: image2,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
    ],
  },
  {
    name: "Amipara Vijay",
    feedback:
      "Absolutely amazing. He was super attentive to detail and you could tell he had really read and remembered my pre assessment questionnaires. He was very thorough and also patient. I would recommend this service to anyone especially with Dr. Anant Changela.",

    img: image1,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
    ],
  },
  {
    name: "Iswarbhai Talati",
    feedback:
      "I have alcohol use and associated anxiety, with treatment of Dr. Anant changela i feel better, maintain abstinance since last 8 month, best deaddiction spacialist and psychiatrist in surat",

    img: image7,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
    ],
  },
  {
    name: "Soumya Pandya",
    feedback:
      "I have migraine, now I feel good and batter with treatment, thanns psynexa, best psychiatrist in surat, excellent hospital environment, thanks psynexa",

    img: image6,
    rate: [
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <LiaStarSolid />,
      <FaStarHalf />,
    ],
  },
];
const Review = () => {
  var settings = {
    dots: true,
    infinite: false,
    autoplay: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="slider-container">
      <Slider {...settings} className="white-dots">
        {reviews.map((review, index) => (
          <div key={index} className=" p-2 mt-10">
            <div className=" w-[350px]  h-[315px]  bg-white relative flex-col justify-items-center mx-auto bg-transparent shadow-sm shadow-[#469B8F] rounded-xl p-2 ">
              <img
                className="h-[80px] w-[80px] rounded-full shadow-lg absolute top-[-35px] left-[40%]  border mb-6 border-black z-30 "
                src={review.img}
                alt="image"
              />
              <FcGoogle className=" absolute top-[13px] left-[187px] bg-white rounded-full  text-3xl z-30" />
              <p className=" font-serif pt-2 uppercase text-center mt-10 text-slate-700 text-xl">
                {review.name}
              </p>

              <p className="flex mt-2 text-yellow-400 text-lg text-center ">
                {review.rate}
              </p>
              <p className=" font-roboto pt-3 py-1 text-justify text-base text-slate-700 ">
                {review.feedback}
              </p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Review;
